document.addEventListener("DOMContentLoaded", function () {
  // Selectors (from the classes you provided)
  const MAIN_ITEM_SELECTOR = ".header__menu-item.list-menu__item";
  const FIRST_LIST_SELECTOR = ".header__submenu.header_submenu_outer";
  const LIST_ITEM_SELECTOR = ".header__menu-item.link.link--text.list-menu__item.focus-inset.caption-large";
  const SECOND_LIST_SELECTOR = ".header__submenu.list-menu--disclosure.list-menu.motion-reduce.color-background-2";

  let lockedSubmenu = null; // currently locked second-level submenu (HTMLElement)

  // Utility helpers
  function open(el) {
    if (!el) return;
    el.classList.add("active");
  }
  function close(el) {
    if (!el) return;
    el.classList.remove("active");
  }
  function closeAllUnlocked() {
    document.querySelectorAll(SECOND_LIST_SELECTOR + ".active, " + FIRST_LIST_SELECTOR + ".active").forEach((s) => {
      if (s === lockedSubmenu) return;
      s.classList.remove("active");
    });
  }

  // For each main menu item (top-level)
  document.querySelectorAll(MAIN_ITEM_SELECTOR).forEach((mainItem) => {
    // find the first-level list inside this mainItem (header-menu-list)
    const firstList =
      mainItem.querySelector(FIRST_LIST_SELECTOR) ||
      (mainItem.nextElementSibling && mainItem.nextElementSibling.matches(FIRST_LIST_SELECTOR)
        ? mainItem.nextElementSibling
        : null);
    if (!firstList) return;

    // show/hide first-level list on pointer events
    const showFirst = () => {
      if (lockedSubmenu) {
        // if locked submenu is not inside this firstList, allow switching to this firstList
        if (
          !lockedSubmenu.closest(FIRST_LIST_SELECTOR) ||
          lockedSubmenu.closest(FIRST_LIST_SELECTOR) !== firstList
        ) {
          closeAllUnlocked();
          open(firstList);
        }
        return;
      }
      closeAllUnlocked();
      open(firstList);
    };

    const hideFirst = () => {
      setTimeout(() => {
        if (!mainItem.matches(":hover") && !firstList.matches(":hover")) {
          if (
            !lockedSubmenu ||
            !lockedSubmenu.closest(FIRST_LIST_SELECTOR) ||
            lockedSubmenu.closest(FIRST_LIST_SELECTOR) !== firstList
          ) {
            close(firstList);
          }
        }
      }, 80);
    };

    mainItem.addEventListener("pointerenter", showFirst);
    mainItem.addEventListener("pointerleave", hideFirst);
    firstList.addEventListener("pointerenter", showFirst);
    firstList.addEventListener("pointerleave", hideFirst);

    // handle each list-item inside this firstList for second-level submenus
    firstList.querySelectorAll(LIST_ITEM_SELECTOR).forEach((listItem) => {
      const secondList =
        listItem.querySelector(SECOND_LIST_SELECTOR) ||
        (listItem.nextElementSibling && listItem.nextElementSibling.matches(SECOND_LIST_SELECTOR)
          ? listItem.nextElementSibling
          : null);
      if (!secondList) return;

      const icon = listItem.querySelector(".icon-caret, .submenu-toggle, .submenu-toggle-button, .caret, .toggle-icon, svg");

      const showSecond = () => {
        if (lockedSubmenu && lockedSubmenu !== secondList) {
          close(lockedSubmenu);
          lockedSubmenu = null;
        }
        open(secondList);
      };

      const hideSecond = () => {
        setTimeout(() => {
          if (
            !listItem.matches(":hover") &&
            !secondList.matches(":hover") &&
            lockedSubmenu !== secondList
          ) {
            close(secondList);
          }
        }, 80);
      };

      listItem.addEventListener("pointerenter", showSecond);
      listItem.addEventListener("pointerleave", hideSecond);
      secondList.addEventListener("pointerenter", showSecond);
      secondList.addEventListener("pointerleave", hideSecond);

      // click on icon toggles lock
      if (icon) {
        icon.addEventListener("click", function (ev) {
          ev.preventDefault();
          ev.stopPropagation();

          if (lockedSubmenu === secondList) {
            close(secondList);
            lockedSubmenu = null;
          } else {
            if (lockedSubmenu) close(lockedSubmenu);
            lockedSubmenu = secondList;
            open(secondList);
            const parentFirst = secondList.closest(FIRST_LIST_SELECTOR);
            if (parentFirst) open(parentFirst);
            document.querySelectorAll(SECOND_LIST_SELECTOR + ".active").forEach((s) => {
              if (s !== lockedSubmenu) close(s);
            });
          }
        });
      }
    });
  });

  // clicking outside closes unlocked submenus
  document.addEventListener("click", function (e) {
    if (lockedSubmenu && lockedSubmenu.contains(e.target)) return;
    if (document.querySelector(FIRST_LIST_SELECTOR + ".active:hover, " + SECOND_LIST_SELECTOR + ".active:hover")) return;
    document.querySelectorAll(FIRST_LIST_SELECTOR + ".active, " + SECOND_LIST_SELECTOR + ".active").forEach((s) => {
      if (s === lockedSubmenu) return;
      s.classList.remove("active");
    });
  });

  // ✅ NEW CODE: hide first-level submenu when mouse leaves it completely
  // — AND clear any lock that belongs to that first-level submenu (fixes the "first nav-link won't reopen" bug)
  document.querySelectorAll(".header__submenu.header_submenu_outer").forEach((submenuOuter) => {
    submenuOuter.addEventListener("mouseleave", function () {
      // hide the first-level submenu
      submenuOuter.classList.remove("active");

      // if the locked submenu belongs to this first-level submenu, close and clear the lock
      try {
        if (lockedSubmenu && lockedSubmenu.closest(FIRST_LIST_SELECTOR) === submenuOuter) {
          close(lockedSubmenu);
          lockedSubmenu = null;
        }
      } catch (err) {
        // safety: if DOM changed and closest fails, just clear the lock reference
        lockedSubmenu = null;
      }
    });

    // optional: ensure it becomes visible again when re-entered (keeps consistent display)
    submenuOuter.addEventListener("mouseenter", function () {
      open(submenuOuter);
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const scrollMenus = document.querySelectorAll(".list-menu.list-menu--disclosure");

  scrollMenus.forEach(menu => {
    let timer;

    menu.addEventListener("scroll", () => {
      menu.classList.add("scrolling");

      clearTimeout(timer);
      timer = setTimeout(() => {
        menu.classList.remove("scrolling");
      }, 600); // fade out delay
    });
  });
});